/** Highlight markers around matched words in document search excerpts (U+0002 … U+0003, ADR-0050). */
const MARK_START = String.fromCharCode(2);
const MARK_END = String.fromCharCode(3);

/** A search excerpt with its matched words highlighted. */
export function SearchSnippet({ text, className }: { text: string; className?: string }) {
  const parts = text.replaceAll(MARK_END, MARK_START).split(MARK_START);
  return (
    <span className={className}>
      {parts.map((part, i) => (i % 2 === 1 ? <mark key={i} className="rounded-sm bg-accent-soft px-0.5 text-accent-soft-fg">{part}</mark> : <span key={i}>{part}</span>))}
    </span>
  );
}
